import React from 'react';
import ReactDOM from 'react-dom/client';
import './main.css';

import { RouterProvider } from 'react-router';
import { router } from './router';
import { Toaster } from 'sonner';
// import { CheckVersion } from '@panamod/general-utils'

// CheckVersion({localStorageKey: 'ENC_GP', alertMessage: 'Se detectó una nueva versión de la aplicación'});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<Toaster position='top-right' richColors/>
		<RouterProvider 
			router={router}
		/>
	</React.StrictMode>
);
